import {
  FiGlobe,
  FiTruck,
  FiPackage,
  FiFileText,
  FiShield,
  FiAnchor,
} from "react-icons/fi";

const services = [
  {
    icon: FiGlobe,
    title: "Global Export Trade",
    summary:
      "End-to-end export of premium Indian spices and seeds to buyers across the Middle East, Europe, South-East Asia, Africa and the Americas.",
    points: [
      "Sourcing direct from growing belts",
      "Multi-origin consolidation",
      "FOB, CIF, CFR and door-to-door terms",
    ],
  },
  {
    icon: FiTruck,
    title: "Integrated Logistics",
    summary:
      "Road, rail, sea and air freight coordinated under one roof — from farm gate to destination port, with real-time tracking.",
    points: [
      "Reefer & dry container management",
      "ICD & port drayage across India",
      "Last-mile distribution abroad",
    ],
  },
  {
    icon: FiPackage,
    title: "Custom Packing & Private Label",
    summary:
      "Retail-ready packs, bulk sacks, or your own branded labels. We adapt packing to the shelf, the climate and the buyer.",
    points: [
      "25/50 kg PP & jute bulk bags",
      "Vacuum, nitrogen-flushed retail packs",
      "Private-label design & compliance",
    ],
  },
  {
    icon: FiFileText,
    title: "Documentation & Compliance",
    summary:
      "Every shipment moves with the paperwork it needs — no surprises at destination customs.",
    points: [
      "Phytosanitary & fumigation certificates",
      "Certificate of Origin · FSSAI · APEDA",
      "Country-specific labelling & HS classification",
    ],
  },
  {
    icon: FiShield,
    title: "Quality Assurance",
    summary:
      "Lab-tested batches, traceable lots and pre-shipment inspection — because reputation travels further than cargo.",
    points: [
      "Moisture, purity & pesticide testing",
      "Third-party inspection on request",
      "Sample approval before every shipment",
    ],
  },
  {
    icon: FiAnchor,
    title: "Port & Customs Clearance",
    summary:
      "Licensed CHA partners at Mundra, Kandla, Nhava Sheva and JNPT — shipments clear faster and cleaner.",
    points: [
      "CHA coordination at major Indian ports",
      "EDI filing & duty drawback support",
      "Destination clearance assistance",
    ],
  },
];

export default services;
